import React from 'react';
import styled from 'styled-components';

import IconButtonBase from '../IconButton';
import FileIcon from '../Icons/Attachment';

const AttachmentButton = React.forwardRef(
  ({ icon, hoverBackground, background, borderRadius, ...props }, ref) => (
    <IconButton
      type="button"
      textColor={icon.color}
      background={background}
      hoverBackground={hoverBackground}
      borderRadius={borderRadius}
      {...props}
      ref={ref}
    >
      {icon && <FileIcon width={icon.size} height={icon.size} fill={icon.color} />}
    </IconButton>
  )
);

AttachmentButton.displayName = 'AttachmentButton';

const IconButton = styled(IconButtonBase)`
  padding: 0.5em;
  background: ${props => props.background};
  border-radius: ${props => props.borderRadius};

  &:hover {
    background: ${props => props.hoverBackground};
  }

  & svg {
    fill: ${props => props.textColor};
  }
`;

export default AttachmentButton;
